module.exports = __webpack_public_path__ + "media/images/s2ep6-cindy-d5024ab6303d12b14532c653e5623ca8.png";